import React from 'react'
import TenantMontlyRent from '../Components/Monthly rent/Tenant/TenantMontlyRent'

const TenantMonthlyRentPage = () => {
  return (
    <TenantMontlyRent />
  )
}

export default TenantMonthlyRentPage